import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    $(document).ready(function () {
        var selector = "#hero";
        if (!$(selector).length) return;

        jdmn.log("custom_chapter-title.js initialized", "green");
        gsap.registerPlugin(ScrollTrigger);

        var $instance = $(selector);
        var $keyvisual = $instance.find("img");
        var $wave = $instance.find(".moving-wave");
        var scale = 1.5;

        $keyvisual.on("load", function () {
            setTimeout(function () {
                $instance
                    .find(".headline span, .flagline, .subline")
                    .addClass("on")
                    .one("transitionend", function () {
                        $("html").addClass("intro-finished");
                    });
            }, 500);
        });

        gsap.fromTo(
            $keyvisual[0],
            {
                y: `${(1 - scale) * -50}%`,
                scale: scale,
            },
            {
                y: `${(1 - scale) * 50}%`,
                scale: scale,
                ease: "none",
                force3D: true,
                scrollTrigger: {
                    scroller: window,
                    trigger: $instance[0],
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1,
                },
            }
        );

        new ScrollTrigger({
            scroller: window,
            trigger: $instance[0],
            endTrigger: "html",
            start: `bottom-=${$wave.height()} top`,
            end: "bottom top",
            onToggle: function () {
                $("html").toggleClass("hero-passed");
            },
        });

        /*
        $images.each(function () {
            $(this).one("load", function () {
                loaded++;
                if (loaded === total) {
                    setTimeout(function () {
                        $images.addClass("on").on("transitionend", function () {
                            $instance
                                .find(".overlay-wrapper")
                                .addClass("on")
                                .on("transitionend", function () {
                                    $instance.find(".slide-up").addClass("on");
                                    $("html").addClass("intro-finished");
                                });
                        });
                    }, 500);
                }
            });
        });
        */
    });
})();
